var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banners"},[(_vm.ready)?_c('admin-banners',{attrs:{"banners":_vm.banners,"links":_vm.bannerLinks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }